import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserMasterComponent } from '../user-master/user-master.component';
import { PermissionComponent } from '../permission/permission.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { localizedString } from '@angular/compiler/src/output/output_ast';
import { UserDialogBoxComponent } from '../user-dialog-box/user-dialog-box.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
@Component({
  selector: 'app-user-tab',
  templateUrl: './user-tab.component.html',
  styleUrls: ['./user-tab.component.scss']
})
export class UserTabComponent implements OnInit {
  selectedIndex: number = 0;
  disable: Boolean = true;
  userPermission: any;
  userType: any;
  permissionList = [];
  CustomerSettingView = true;
  UserSettingView = true;
  UserPermissionsView = true;
  userForm: FormGroup;
  readonlyUpdate = false;
  tabEnable = true;
  dialogRef: MatDialogRef<any>;
  userData: any;
  submitpayload: any;
  hidePass: boolean;
  updateButton: boolean;
  submitButton: boolean;
  arrayLogin = [];
  UserSearch: FormGroup;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  viewChangepassword=true;
  utp: any;
  setIntervalSearch: any;
  constructor(
    private change: ChangeDetectorRef,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { }

  @ViewChild(UserMasterComponent, { static: false }) private UserMaster: UserMasterComponent;
  @ViewChild(PermissionComponent, { static: false }) private Permissions: PermissionComponent;
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Change Password' && element.PView == false) {
          this.viewChangepassword = false;
        }
       
      });
    }
    window.scroll(0, 0)
    this.hidePass = true;
    this.tabEnable = true;
    this.updateButton = false;
    this.submitButton = true;
    this.readonlyUpdate = false;
    this.userForm = this.fb.group({
      LoginFullName: new FormControl('', [Validators.required]),
      LoginPass: new FormControl('', [Validators.required]),
      LoginName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')])
    })

    this.getUserData()
    this.UserSearch = this.fb.group({
      SearchString: new FormControl(''),
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.userData = [];
      let payload = {};
      payload['SearchString'] = this.UserSearch.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.SearchUser(payload).subscribe(res => {
        if(res.status){
          this.userData = res.data[0];
          this.totalItems = res.data[0][0].TotalRecords;
        }
        else{
          this.userData = [];
        this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.userData = [];
      });
    },1000)
  
  }

  onTabChanged(event: MatTabChangeEvent) {
    if (event.tab.textLabel == 'User Master') {
      this.UserMaster.ngOnInit();//Or whatever name the method is called
      this.disable = true;
    }
    else if (event.tab.textLabel == 'Permission') {
      this.Permissions.ngOnInit();//Or whatever name the method is called
    }

  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    // const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getUserData();
    this.keypress();
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {

    this.selectedIndex = tabChangeEvent.index;
  }

  public next() {


    this.disable = false;
    this.selectedIndex += 1;
    // this.Permissions.ngOnInit();
  }

  public prev() {
    this.selectedIndex -= 1;
    // this.UserMaster.ngOnInit();
    this.disable = true;
  }

  public enable() {
    this.disable = false;
    // this.Permissions.ngOnInit();
  }


  ngOnChanges(changes: UserTabComponent) {
  }
  redirect(to): void {
    this.router.navigate([to]);
  }


  submit() {
    if (this.userForm.invalid) {
      this.userForm.get('LoginFullName').markAsTouched();
      this.userForm.get('LoginName').markAsTouched();
      this.userForm.get('LoginPass').markAsTouched();
      return;
    } else {
      this.saveUser();
    }
  }
  saveUser() {
    this.spinner.show();
    this.submitpayload = this.userForm.value;
    this.umsService.addUserForPermission(this.submitpayload).subscribe(res => {
      sessionStorage.setItem('UserName', 'LoginName');
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.userForm.reset();
        // this.ngOnInit();
        this.dialogRef.afterClosed().subscribe(result => {
          this.next();
        });

      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getUserData() {
    // let param = 0;
    // let payload = {};
    // // payload[''] = 0;
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    this.umsService.getUsers(this.pageSize, this.currentPage).subscribe((res) => {
      if(JSON.parse(sessionStorage.getItem('userPermission'))[0]['CgUi'] == 'U'){
        this.userData = res.data[0];
        this.totalItems = res.data[0][0].TotalRecords;
      }
      else if(JSON.parse(sessionStorage.getItem('userPermission'))[0]['CgUi'] == 'C'){
        const filteredArray = res.data[0].filter(obj => obj.CgId === JSON.parse(sessionStorage.getItem('userPermission'))[0]['CgId']);
        this.userData = filteredArray;
        this.totalItems = filteredArray.TotalRecords;
      }
      

    });
  }

  prepopulateData(id) {
    this.spinner.show();
    let payload = id.LoginId;
    this.tabEnable = false;
    this.hidePass = false;
    this.updateButton = true;
    this.submitButton = false;
    this.readonlyUpdate = true;
    this.umsService.getOneUsers(payload).subscribe((res) => {
      if (res.status) {
        let data = res.data[0][0];

        // let arr1 = [];
        this.arrayLogin.push(
          this.fb.group({
            LoginAccess: new FormControl(res.data[0][0].LoginAccess),
            LoginId: new FormControl(res.data[0][0].LoginId),
            LoginLevel: new FormControl(res.data[0][0].LoginLevel),
            LoginStatus: new FormControl(res.data[0][0].LoginStatus),
          })
        )
        sessionStorage.setItem('loginId', data.LoginId)
        sessionStorage.setItem('loginName', data.LoginFullName)
        this.spinner.hide();
        this.userForm = this.fb.group({
          LoginFullName: new FormControl(data.LoginFullName),
          LoginName: new FormControl(data.LoginName),
          LoginPass: new FormControl(data.LoginPass),
        });

      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  reset() {
    this.userForm.reset();
    this.ngOnInit();
    // this.tabEnable =true;
  }
  Update() {
    this.spinner.show();
    this.updateButton = true;
    this.submitButton = false;
    this.submitpayload = this.userForm.value;
    let arrayLogin1 = []
    this.arrayLogin.push(
      this.fb.group({
        LoginFullName: new FormControl(this.submitpayload.LoginFullName),
        LoginName: new FormControl(this.submitpayload.LoginName),
      })
    )
    const mergedObject = this.arrayLogin.reduce((result, formGroup) => {
      const formGroupValue = formGroup.getRawValue(); // Get the raw value of the FormGroup 
      return { ...result, ...formGroupValue };
    }, {});

    this.umsService.updateUserForPermission(mergedObject).subscribe(res => {
      sessionStorage.setItem('UserName', 'LoginName');
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.userForm.reset();
        this.ngOnInit();
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  addnewrecord() {
    const dialogRef = this.dialog.open(UserDialogBoxComponent, {
      width: '37%',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getUserData();
      this.UserSearch.controls['SearchString'].setValue('');
    });
  }
  editData(k) {
    const dialogRef = this.dialog.open(UserDialogBoxComponent, {
      width: '45%',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getUserData();
      this.UserSearch.controls['SearchString'].setValue('');
    });
  }
  deleteData(k) {
    const dialogRef = this.dialog.open(UserDialogBoxComponent, {
      width: '37%',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getUserData();
      this.UserSearch.controls['SearchString'].setValue('');
    });
  }

  changePassword() {
    // this.redirect('change-password')
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '37%',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getUserData();
      this.UserSearch.controls['SearchString'].setValue('');
    });
  }
}